import { render, staticRenderFns } from "./TemplateFormInfoAssembly.vue?vue&type=template&id=57f6b160&scoped=true"
import script from "./TemplateFormInfoAssembly.vue?vue&type=script&lang=js"
export * from "./TemplateFormInfoAssembly.vue?vue&type=script&lang=js"
import style0 from "./TemplateFormInfoAssembly.vue?vue&type=style&index=0&id=57f6b160&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6b160",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f6b160')) {
      api.createRecord('57f6b160', component.options)
    } else {
      api.reload('57f6b160', component.options)
    }
    module.hot.accept("./TemplateFormInfoAssembly.vue?vue&type=template&id=57f6b160&scoped=true", function () {
      api.rerender('57f6b160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo/TemplateFormInfoAssembly.vue"
export default component.exports